// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"530460df","312":"530460df","1173":"530460df","1435":"bcf01700","5364":"530460df","6140":"530460df","7720":"530460df"}[chunkId] + ".chunk.css";
};